const initMember = {
  members: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterTenantPage: "",
  filterTierPage: "",
  filterPortalPage: "",
  filterBlacklistPage: "",
  memberTierFilters: ["All", "Explorer", "Adventurer", "Voyager", "Legend"],
  memberPortalFilters: ["All", "Chatbot", "Web"],
  isFilterLoading: false,
  isFormLoading: false,
};

export const memberReducer = (state = initMember, action: any) => {
  if (action.type === "SET_MEMBER") {
    return {
      ...state,
      members: action.value,
    };
  }
  if (action.type === "SET_MEMBER_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_MEMBER_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_MEMBER") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_MEMBER_FILTER_PAGE") {
    return {
      ...state,
      filterTenantPage: action.filterTenantPage,
      filterTierPage: action.filterTierPage,
      filterPortalPage: action.filterPortalPage,
      filterBlacklistPage: action.filterBlacklistPage,
    };
  }
  if (action.type === "SET_FORM_VERIFY_KTP_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  return state;
};
